import styles from "./ThankYouModal.module.css";

const COPY_BY_FORM_TYPE = {
  "Investment Pitch": {
    titleLine: "Thanks for your Interest in",
    blocks: [
      {
        type: "subtitle",
        text: "Check your email to see the 1 Pager",
      },
      {
        type: "p",
        text: (email) => (
          <>
            We have sent the investment opportunity 1 pager to your email{" "}
            <strong>{email}</strong> – We are very happy to see your interest in
            Rexpt and would love to take it further.
          </>
        ),
      },
      {
        type: "p",
        className: "ps",
        text: () => (
          <>
            <strong>PS:</strong> Great Choice, Investing in Future of CX
          </>
        ),
      },
    ],
  },

  "Enterprise Solution": {
    titleLine: "Thanks for Your Interest in",
    blocks: [
      {
        type: "subtitle",
        text: "We have successfully received your inquiry for our Enterprise Solution.",
      },
      {
        type: "p",
        text: () =>
          "We're excited to explore this opportunity with you and a dedicated specialist will be in touch shortly to schedule your personalized consultation.",
      },
      {
        type: "p",
        text: (email) => (
          <>
            Check your inbox! We've sent a quick confirmation and brief overview
            to <strong>{email}</strong>.
          </>
        ),
      },
    ],
  },

  "Reseller Program": {
    titleLine: "Thanks for Your Interest in",
    blocks: [
      {
        type: "subtitle",
        text: "We have successfully received your inquiry for our Reseller Program.",
      },
      {
        type: "p",
        text: () =>
          "We're excited to explore this opportunity with you, and a member of our Partnership Team will contact you shortly to discuss the next steps and partnership details.",
      },
      {
        type: "p",
        text: (email) => (
          <>
            We've sent a confirmation email with a brief overview to{" "}
            <strong>{email}</strong>.
          </>
        ),
      },
    ],
  },

  Whitelabel: {
    titleLine: "Thanks for Your Interest in",
    blocks: [
      {
        type: "subtitle",
        text: "We have successfully received your inquiry for our White Label Program.",
      },
      {
        type: "p",
        text: () =>
          "We are excited to explore this opportunity with you, and a  dedicated REXPT Partnership Manager will contact you shortly to discuss integration, branding, and next steps.",
      },
      {
        type: "p",
        text: (email) => (
          <>
            A confirmation and brief overview has been sent to{" "}
            <strong>{email}</strong>.
          </>
        ),
      },
    ],
  },

  // fallback
  default: {
    titleLine: "Thanks for Your Interest in",
    blocks: [
      {
        type: "subtitle",
        text: "Check your email to see the 1 Pager",
      },
      {
        type: "p",
        text: (email) => (
          <>
            We have sent the investment opportunity 1 pager to your email{" "}
            <strong>{email}</strong> – We are very happy to see your interest in
            Rexpt and would love to take it further.
          </>
        ),
      },
      {
        type: "p",
        className: "ps",
        text: () => (
          <>
            <strong>PS:</strong> Great Choice, Investing in Future of CX
          </>
        ),
      },
    ],
  },
};

const ThankYouModal = ({ open, onClose, onTryAgain, email, formType }) => {
  console.log(formType,"formYyptt")
  if (!open) return null;

  const handleTryAgain = () => {
    if (onTryAgain) {
      onTryAgain();
    } else if (onClose) {
      onClose();
    }
  };

  const config = COPY_BY_FORM_TYPE[formType] || COPY_BY_FORM_TYPE.default;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>
          {config.titleLine}
          <br />
          <img
            src="/Images/rexpt_logo.png"
            alt="Rexpt Logo"
            className={styles.logo}
          />
        </h2>

        {config.blocks.map((block, idx) => {
          if (block.type === "subtitle") {
            return (
              <p key={idx} className={styles.SubTitle}>
                {typeof block.text === "function"
                  ? block.text(email)
                  : block.text}
              </p>
            );
          }

          const className =
            block.className === "ps" ? styles.ps : styles.message;

          return (
            <p key={idx} className={className}>
              {typeof block.text === "function"
                ? block.text(email)
                : block.text}
            </p>
          );
        })}

        <div className={styles.buttonRow}>
          <button className={styles.tryAgainBtn} onClick={handleTryAgain}>
            Try Again
          </button>

          <button className={styles.okBtn} onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
